export default __webpack_public_path__ + "static/media/sh-link-active.877c2dfc.svg";